import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    changeCamPosition,
    changeImageKey,
    changeLevel,
    ifloorplanStateAdd,
    setOpenImageMarkers,
    nextStep,
    setColor,
    setColorBackground,
    setColorText,
    setMarkerWidth,
    set360MarkerWidth,
    setIsPreviewMarker,
    setIsPreviewMarker360
} from '../redux/actions/actions';
import { getSystemIcons, getUserIcons } from "../serverRequests/requests";
import CustomButtons from './CustomButtons'


const ImageMarkersStudio = (props) => {
    const [loadedSystIcons, setLoadedSystIcons] = useState([]);
    const [loadedUserIcons, setLoadedUserIcons] = useState([]);
    const [loadedSyst360Icons, setLoadedSyst360Icons] = useState([]);
    const [loadedUser360Icons, setLoadedUser360Icons] = useState([]);

    const [showSystemIcons, setShowSystemIcons] = useState(true);
    const [saveLastState, setSaveLastState] = useState({});

    const [swapMarkButt, setSwapMarkButt] = useState(false);
    const [markersButtons, setMarkersButtons] = useState(false);
    const [panelPosition, setPanelPosition] = useState(false) // false: left, true: right

    useEffect(() => {
        getSystemIcons()
            .then((data) => {
                const icons = [];
                const pan_icons = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].type === "IMAGE") {
                        icons.push(data[i]);
                    }
                    if (data[i].type === "PANORAMA") {
                        pan_icons.push(data[i]);
                    }
                }
                setLoadedSystIcons(icons);
                setLoadedSyst360Icons(pan_icons);
            });
        getUserIcons()
            .then((data) => {
                const icons = [];
                const pan_icons = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].type === "IMAGE") {
                        icons.push(data[i]);
                    }
                    if (data[i].type === "PANORAMA") {
                        pan_icons.push(data[i]);
                    }
                }
                setLoadedUserIcons(icons);
                setLoadedUser360Icons(pan_icons);
            });
        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        setSaveLastState(newState);

        function readCookie(name) {
            //function split cookie for get csrf token
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }
    }, []);

    const chooseSysIcons = () => {
        setShowSystemIcons(true)
    }
    const chooseMyIcons = () => {
        setShowSystemIcons(false)
    }

    const setIcons = (index, type) => {
        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        if (type == "system") {
            newState.system_marker = loadedSystIcons[index].id
            newState.user_marker = null;
            newState.marker_image = loadedSystIcons[index].marker;
            newState.marker_image_hover = loadedSystIcons[index].marker_hover;
        }
        else {
            newState.user_marker = loadedUserIcons[index].id
            newState.system_marker = null;
            newState.marker_image = loadedUserIcons[index].marker;
            newState.marker_image_hover = loadedUserIcons[index].marker_hover;
        }
        props.setIsPreviewMarker(true);
        props.ifloorplanStateAdd(newState);
    }

    const set360Icons = (index, type) => {
        const newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        if (type == "system") {
            newState.system_360marker = loadedSyst360Icons[index].id
            newState.user_360marker = null;
            newState.marker360_image = loadedSyst360Icons[index].marker;
            newState.marker360_image_hover = loadedSyst360Icons[index].marker_hover;
        }
        else {
            newState.user_360marker = loadedUser360Icons[index].id
            newState.system_360marker = null;
            newState.marker360_image = loadedUser360Icons[index].marker;
            newState.marker360_image_hover = loadedUser360Icons[index].marker_hover;
        }
        props.setIsPreviewMarker360(true);
        props.ifloorplanStateAdd(newState);
    }

    const CloseMarkStudio = () => {
        let markStidio = document.querySelector('.selectMark_wrapper')
        markStidio.style.left = '-30%'
        const timer = setTimeout(() => {
            props.setOpenImageMarkers(false)
        }, 500);
        return () => clearTimeout(timer);
    }

    const CancelMarker = () => {
        props.ifloorplanStateAdd(saveLastState)
        CloseMarkStudio();
    }

    useEffect(() => {
        if (props.image_key >= 0)
            setSwapMarkButt(props.ifloorplanNowState.level[props.levelNowId].images[props.image_key].button);
        else if (props.pannellum_key >= 0) setSwapMarkButt(props.ifloorplanNowState.level[props.levelNowId].panelum[props.pannellum_key].button);
    }, [props.image_key, props.pannellum_key]);

    return (
        <div className="selectMark_wrapper"
            style={{
                left: panelPosition ? "77%" : "0%",
            }}>
            <h4>Image Markers</h4>
            <div className="move-marker-panel"
                style={{
                    left: panelPosition ? "0%" : "90%",
                }}
                onClick={() => {
                    setPanelPosition(!panelPosition);
                }}>
                {panelPosition ? "<<" : ">>"}
            </div>

            <div className="selectMark" style={{ display: markersButtons ? "none" : "block" }}>
                {/*<div className="selectMark__action">*/}
                {/*    <h5>Select a Marker for all images</h5>*/}
                {/*</div>*/}
                <div className="selectMark__select">
                    <a onClick={chooseSysIcons}>Markers</a>
                    <a onClick={chooseMyIcons}>My Markers</a>
                </div>
                <div className="image_marker">
                    <p>{markersButtons ? "Create a button and swap with a marker" : "Select a Marker below to replace all Image Markers"}</p>
                    <div className="selectMark__markers">
                        {showSystemIcons
                            ?
                            loadedSystIcons.map((el, index) => (
                                <div className="selectMark__markers_item markers" key={index} onClick={() => {
                                    setIcons(index, "system")
                                }}>
                                    <img src={el.marker} alt="" />
                                </div>
                            ))
                            :
                            loadedUserIcons.map((el, index) => (
                                <div className="selectMark__markers_item markers" key={index} onClick={() => {
                                    setIcons(index, "user")
                                }}>
                                    <img src={el.marker} alt="" />
                                </div>
                            ))
                        }
                    </div>
                    <div className="scale-wrapper">
                        <h3 id='test'>Scale image markers</h3>
                        <input type="range"
                            id='markersSize'
                            step="0.1"
                            className="scale-image"
                            min="2"
                            max="10"
                            value={props.marker_width}
                            onChange={(event => props.setMarkerWidth(event.target.value))} />
                    </div>
                </div>

                <div className="pan_marker">
                    <p>{markersButtons ? "Create a button and swap with a 360 marker" : "Select a Marker below to replace all 360 Image Markers"}</p>
                    <div className="selectMark__markers">
                        {showSystemIcons
                            ?
                            loadedSyst360Icons.map((el, index) => (
                                <div className="selectMark__markers_item markers" key={index} onClick={() => {
                                    set360Icons(index, "system")
                                }}>
                                    <img src={el.marker} alt="" />
                                </div>
                            ))
                            :
                            loadedUser360Icons.map((el, index) => (
                                <div className="selectMark__markers_item markers" key={index} onClick={() => {
                                    set360Icons(index, "user")
                                }}>
                                    <img src={el.marker} alt="" />
                                </div>
                            ))
                        }
                    </div>
                    <div className="scale-wrapper">
                        <h3 id='test'>Scale 360 markers</h3>
                        <input type="range"
                            id='markersSize'
                            step="0.1"
                            className="scale-image"
                            min="2"
                            max="10"
                            value={props.pan_marker_width}
                            onChange={(event => props.set360MarkerWidth(event.target.value))} />
                    </div>
                </div>

                <h4>Or</h4>
                <button
                    className="chooseMarkButt"
                    onClick={() => {
                        setMarkersButtons(!markersButtons)
                    }}>
                    Create a button
                </button>
                <h5>and swap it with a Marker</h5>
            </div>
            <CustomButtons display={markersButtons ? "block" : "none"}
                swapMarkButt={swapMarkButt}
                setSwapMarkButt={setSwapMarkButt}
                setMarkersButtons={setMarkersButtons} />
            <div className="selectMark__btns">
                <button className="cancel"
                    onClick={() => {
                        props.setIsPreviewMarker(false);
                        props.setIsPreviewMarker360(false);
                        CancelMarker();
                    }}>
                    Cancel
                </button>
                <button className="done" onClick={() => {
                    props.setIsPreviewMarker(false);
                    props.setIsPreviewMarker360(false);
                    CloseMarkStudio();
                }}>
                    Done
                </button>
            </div>
        </div>
    )
}
const putState = (state) => {
    return {
        step: state.step,
        levelNowId: state.levelNowId,
        cam_key: state.cam_key,
        image_key: state.image_key,
        positionCams: state.positionCams,
        ifloorplanNowState: state.ifloorplanNowState,
        text_color: state.text_color,
        background_color: state.background_color,
        set_color: state.set_color,
        marker_width: state.marker_width,
        pan_marker_width: state.pan_marker_width,
        pannellum_key: state.pannellum_key,
        is_preview_marker: state.is_preview_marker,
        is_preview_marker_360: state.is_preview_marker_360,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        changeCamKey: (key) => dispatch(changeCamKey(key)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        changeCamPosition: (obj) => dispatch(changeCamPosition(obj)),
        setColor: (bool) => dispatch(setColor(bool)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
        setColorBackground: (color) => dispatch(setColorBackground(color)),
        setColorText: (color) => dispatch(setColorText(color)),
        setOpenImageMarkers: (bool) => dispatch(setOpenImageMarkers(bool)),
        setMarkerWidth: (width) => dispatch(setMarkerWidth(width)),
        set360MarkerWidth: (width) => dispatch(set360MarkerWidth(width)),
        setIsPreviewMarker: (bool) => dispatch(setIsPreviewMarker(bool)),
        setIsPreviewMarker360: (bool) => dispatch(setIsPreviewMarker360(bool)),
    }
}


export default connect(putState, putActions)(ImageMarkersStudio);
